import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';
import { timeAgo } from '/@/modules/core/app/helpers/DateHelper';

export class HubspotMeetingNote extends BaseModel {
  /**
   * @var {number}
   */
  estateId;

  /**
   * @var {number}
   */
  hubspotDealId;

  /**
   * @var {number}
   */
  engagementId;

  /**
   * @var {string}
   */
  authorFullName;

  /**
   * @var {?string}
   */
  body;

  /**
   * @var {Date}
   */
  createdAt;

  constructor(model = {}) {
    super();

    this.estateId = model.estateId;
    this.hubspotDealId = model.hubspotDealId;
    this.engagementId = model.engagementId;
    this.authorFullName = model.authorFullName;
    this.body = model.body;
    this.createdAt = model.createdAt;
  }

  /**
   * @returns {string}
   */
  get timeAgoCreatedAt() {
    return timeAgo(this.createdAt);
  }
}
